import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3891bb5f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "leaderboard-container" }
const _hoisted_2 = {
  key: 0,
  class: "title"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoopedTimer = _resolveComponent("LoopedTimer")!
  const _component_LeaderboardPodiumItem = _resolveComponent("LeaderboardPodiumItem")!
  const _component_LeaderboardPlayerItem = _resolveComponent("LeaderboardPlayerItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_LoopedTimer, { timer: _ctx.timer }, null, 8, ["timer"]),
    _createElementVNode("div", {
      ref: "parentRef",
      class: _normalizeClass(["leaderboard-grid", {
        'leaderboard-grid--with-title': _ctx.title,
        'leaderboard-grid--loading': _ctx.isLoading,
      }])
    }, [
      (_ctx.title)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.title), 1))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.podiumEntries, (entry) => {
        return (_openBlock(), _createBlock(_component_LeaderboardPodiumItem, {
          key: entry.index,
          "leaderboard-entry": entry,
          "user-display-format": _ctx.userDisplayFormat
        }, null, 8, ["leaderboard-entry", "user-display-format"]))
      }), 128)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.playerEntries, (entry) => {
        return (_openBlock(), _createBlock(_component_LeaderboardPlayerItem, {
          key: entry.index,
          "leaderboard-entry": entry,
          "user-display-format": _ctx.userDisplayFormat
        }, null, 8, ["leaderboard-entry", "user-display-format"]))
      }), 128))
    ], 2)
  ]))
}